import { $alert } from 'signals/global.signals';

const displayNotification = ({
  message,
  title = 'Success',
  timeOut = 3000,
  variant = 'success',
}) => $alert.update({
  variant,
  message,
  title,
  timeOut,
});

export default displayNotification;
